const DEFAULT_HEADER_HEIGHT = 40;
/** DataTable toolbar row (`my-2` + `h-[40px]`). */
const DATA_TABLE_TOOLBAR_HEIGHT = 56;

interface CompactTableHeightOptions {
  rowCount: number;
  rowHeight: number;
  headerHeight?: number;
  /** Set when the table renders the action/search/filter toolbar above the grid. */
  includeToolbar?: boolean;
}

/** Pixel height for a shrink-wrapped DataTable wrapper (header + rows + optional toolbar). */
export const computeCompactDataTableHeight = ({
  rowCount,
  rowHeight,
  headerHeight = DEFAULT_HEADER_HEIGHT,
  includeToolbar = false,
}: CompactTableHeightOptions): number => {
  const rows = Math.max(rowCount, 1);
  const gridHeight = headerHeight + rows * rowHeight + 1;
  return includeToolbar ? DATA_TABLE_TOOLBAR_HEIGHT + gridHeight : gridHeight;
};
